/**
 * If the user configures a trade plan start time that does not make sense for
 * the requested session. For example, a user may request the premarket session
 * but set the start time to 9:30.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645464707926,
	"notificationDetails": {"errorType":"TRADE_PLAN_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "START_TIME_AFTER_MARKET_PERIOD",
	"statusDetails": {"startHour":9,"startMin":30,"desiredPeriod":"pre"},
	"date": "2022-02-21T12:31:48.897-0500",
	"timestamp": "1645464708898"
}

 * @param {*} statusDetails 
 * @returns an object with fields:
 * 1) startHour: the hour the tradeplan is set to start for
 * 2) startMin: the hour min tradeplan is set to start for
 * 3) desiredPeriod: either premarket, open, postmarket, closed. The session
 *    the user wants to trade in.
 */
export function startTimeAfterMarketPeriod(statusDetails) {
  const parsedObj = {
    startHour: null,
    startMin: null,
    desiredPeriod: null,
  };
  if (statusDetails) {
    parsedObj.startHour = statusDetails.startHour ?? null;
    parsedObj.startMin = statusDetails.startMin ?? null;
    parsedObj.desiredPeriod = statusDetails.desiredPeriod ?? null;
  }

  return parsedObj;
}
